// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__UNslm","colMaxWidth":"Table_colMaxWidth__2j3YE"};